import { getEnumeration } from 'enumeration'
import { sampleType } from 'json/goods-order-options'
import { sexArr } from 'json/customer-options'
export let allLabels = [{
  label: '样本条码号',
  value: 'sampleId'
}, {
  label: '套餐名称',
  value: 'detectionPackageNames'
}, {
  label: '操作结果',
  value: 'message'
}, {
  label: '原因',
  value: 'reason'
}]
export let DATA_ANALYSISED_LABELS = [{
  label: '样本条码号',
  value: 'sampleId'
}, {
  label: '生产条码号',
  value: 'labCode'
}, {
  label: '套餐名称',
  value: 'detectionPackageNames'
}, {
  label: '操作结果',
  value: 'message'
}, {
  label: '原因',
  value: 'reason'
}]
export let LAB_SAMPLES_RECEIVED_LABELS = [{
  label: '样本条码号',
  value: 'sampleId'
}, {
  label: '生产条码号',
  value: 'labCode'
}, {
  label: '姓名',
  value: 'patientName'
}, {
  label: '性别',
  value: 'patientGender'
}, {
  label: '样本类型',
  value: 'sampleType'
}, {
  label: '套餐名称',
  value: 'detectionPackageNames'
}, {
  label: '实验室检测平台',
  value: 'sequencingTechnologyType'
}, {
  label: '操作结果',
  value: 'message'
}, {
  label: '原因',
  value: 'reason'
}]
export let ADULT_LAB_SAMPLES_RECEIVED_LABELS = [{
  label: '样本条码号',
  value: 'sampleId'
}, {
  label: '生产条码号',
  value: 'labCode'
}, {
  label: '受检者姓名',
  value: 'patientName'
}, {
  label: '受检者性别',
  value: 'patientGender'
}, {
  label: '样本类型',
  value: 'sampleType'
}, {
  label: '检测套餐',
  value: 'detectionPackageNames'
}, {
  label: '操作结果',
  value: 'message'
}, {
  label: '原因',
  value: 'reason'
}]
export function getCurrentLables (isShowReason, status, isAdult = false) {
  if (isAdult) {
    return adultLabel(isShowReason, status)
  }
  let labels = allLabels
  if (status === '样本接收' || status === '核酸提取') {
    labels = LAB_SAMPLES_RECEIVED_LABELS
  }
  if (status === '上机检测') {
    labels = DATA_ANALYSISED_LABELS
  }
  if (!isShowReason) {
    return labels.slice(0, labels.length - 1)
  }
  return labels
}
function adultLabel (isShowReason, status) {
  let labels = allLabels
  if (status === '样本接收' || status === '制备') {
    labels = ADULT_LAB_SAMPLES_RECEIVED_LABELS
  }
  if (!isShowReason) {
    return labels.slice(0, labels.length - 1)
  }
  return labels
}
export function handleData (data) {
  let res = JSON.parse(JSON.stringify(data))
  res.forEach(ele => {
    ele.sampleType = getEnumeration(ele.sampleType, sampleType)
    ele.patientGender = getEnumeration(ele.patientGender, sexArr)
  })
  return res
}
